import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Card, CardContent } from '@mui/material';
import { useGetAwardAreaByIdQuery } from './api/awardareaApi';

const AwardAreaDetailPage = () => {
  const { id } = useParams();
  const { data, error, isLoading } = useGetAwardAreaByIdQuery(id!);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={4}>
        <Alert severity="error">Error loading award area details</Alert>
      </Box>
    );
  }

  if (!data) {
    return (
      <Box mt={4}>
        <Alert severity="warning">Award area not found</Alert>
      </Box>
    );
  }

  const awardArea = data.data;

  return (
    <Box sx={{ py: 4, px: { xs: 2, md: 4 } }}>
      <Card>
        <CardContent>
          <Typography variant="h3" component="h1" gutterBottom>
            {awardArea.name}
          </Typography>
          <Typography variant="body1" paragraph>
            {awardArea.description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AwardAreaDetailPage;